<script setup lang="ts">
import { ref, watch, onUnmounted } from 'vue';
import Message from 'primevue/message';
import { useWs } from '@/shell/stores/ws';

const ws = useWs();
const showBanner = ref(false);
let timer: ReturnType<typeof setTimeout> | null = null;

watch(
  () => ws.isDisconnected,
  (disconnected) => {
    if (disconnected) {
      timer = setTimeout(() => { showBanner.value = true; }, 2000);
    } else {
      if (timer) { clearTimeout(timer); timer = null; }
      showBanner.value = false;
    }
  },
  { immediate: true },
);
onUnmounted(() => { if (timer) { clearTimeout(timer); timer = null; } });
</script>

<template>
  <Message
    v-if="showBanner"
    severity="warn"
    icon="pi pi-wifi"
    :closable="false"
    role="status"
    aria-live="polite"
    data-testid="connection-lost-banner"
  >
    Reconnecting…
  </Message>
</template>
